import React, { useState, lazy, useEffect, Suspense } from "react";

import coupon_icon from "../static/img/icon-btn/coupon-icon.png";

import sport_icon from "../static/img/icon-btn/sport-icon.png";

import sportlive_icon from "../static/img/icon-btn/sport-live-icon.png";

import slot_icon from "../static/img/icon-btn/slot-icon.png";

import casino_live_icon from "../static/img/icon-btn/live-game-icon.png";

import crash_game_icon from "../static/img/icon-btn/crash-game-icon.png";

import bingo_icon from "../static/img/icon-btn/bingo-icon.png";

import virtual_icon from "../static/img/icon-btn/virtual-icon.png";
import { useTranslation } from "react-i18next";

import Game from "../../../class/Game/Game";
import Games from "../../../class/Game_copy/Game";

import AuthService from "../../../class/services/AuthService";

import gift from "../box_button/assets/gift.png";

import LOAD_GAMES_BY_PROVIDER_ID from "../modal/load_games_by_provider_id";

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const SearchModal = lazy(() => import("../modal/modal_search.js"));

const ModalMenu = lazy(() => import("../modal/modal_menu.js"));

const MobileNavigation = ({
    isLogged,
    onNavigationChange,
    activePage,
    openSingleProviderModal,
    handleOpenSearchModal,
    casinoSections,
    openSingleSubcategoryModal,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [providers, setProviders] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        const fetchProviders = async () => {
            try {
                const providerData = await Games.getProviders(
                    AuthService.getCustom("user_id"),
                    activePage,
                    20,
                    1,
                );

                // const categories = ["Not found", "casino", "casino_live", "poker", "bingo", "virtual", "sport", "crash_games"]
                const categories = {
                    not_found: "Not found",
                    casino: "casino",
                    "casino-live": "casino_live",
                    poker: "poker",
                    bingo: "bingo",
                    virtual: "virtual",
                    sport: "sport",
                    "crash-game": "crash_games",
                };

                // console.log(providerData);
                // Отримуємо всі значення об'єкта data та з'єднуємо їх у один масив
                const providersArray = providerData?.params.providers
                    ? Object.values(providerData.params.providers).flat()
                    : [];

                const filteredProviders = providersArray
                    .map((provider) => {
                        const provider_category =
                            categories[provider.category_slug];
                        return {
                            ...provider,
                            category_name: provider_category,
                        };
                    })
                    .filter(
                        (provider) =>
                            casinoSections[provider.category_name] == false,
                    );

                setProviders(filteredProviders);
            } catch (error) {
                console.error("Error fetching providers:", error);
            }
        };
        fetchProviders();
    }, [AuthService.getCustom("user_id"), activePage]);

    const getProviderIcon = (providerslug) => {
        return `${cmsUrl}static-assets/providers/${providerslug}.png`;
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleButtonClick = (buttonName) => {
        const baseUrl = "https://1xplanet.xframe.live";

        // Визначаємо дію для кожної кнопки
        switch (buttonName) {
            case "sport":
                onNavigationChange("sport", `${baseUrl}/sport/it/`);
                break;
            case "live":
                onNavigationChange("live", `${baseUrl}/live/it/`);
                break;
            case "profile":
                onNavigationChange("profile", "bet_history");
                break;
            case "coupon":
                onNavigationChange("profile", "bet_history"); // ПРАВИЛЬНО!
                break;

            default:
                onNavigationChange(buttonName, "");
        }
    };

    return (
        <>
            <div className="box-casino-search">
                <div className="single-search width-100-d">
                    <div
                        className="input-group"
                        onClick={handleOpenSearchModal}
                    >
                        <input
                            type="button"
                            className="form-control"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            value={t("Search_games") + "..."}
                        />
                        <span className="input-group-text" id="basic-addon1">
                            <svg
                                viewBox="0 0 14 14"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                className="icon icon-search sm margin square icon icon"
                            >
                                <path d="M10.027 8.624c.033.025.064.053.094.083l2.829 2.829a1 1 0 01-1.414 1.414L8.707 10.12a1.01 1.01 0 01-.083-.094 5.5 5.5 0 111.403-1.403zM5.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>

            <div className="container-fluid box-underCarousel">
                {/* <div className="col">
              <div className="box-navigation promotionbox">
              <div className="text">
                  <h4 >Promozioni</h4>
                  <p>Scopri tuttte le nostre offerte</p>
              </div>
              <img src={gift} />
            </div>
        </div> */}
            </div>

            <div className="list-navMenu" style={{ marginBottom: "20%" }}>
                {/* <h3 className="title-section-game">Sport</h3>
        <a 
        className={`list-item-navMenu ${activePage === 'sport' ? 'active' : ''}`}
        onClick={() => handleButtonClick('sport')}
        ><img src="/assets/img/icon-btn/sport-icon.png" alt="Opzione 1"/>Sport</a>
        <a   className={`list-item-navMenu ${activePage === 'live' ? 'active' : ''}`}
        
        onClick={() => handleButtonClick('live')}

        ><img src="/assets/img/icon-btn/sport-live-icon.png" alt="Opzione 1"/>Sport live</a>
        {isLogged && (
        <a 
          className={`list-item-navMenu ${activePage === 'profile/coupon' ? 'active' : ''}`} 
          onClick={() => handleButtonClick('coupon')}
        >
          <img src="/assets/img/icon-btn/coupon-icon.png" alt="Opzione 1"/>Coupon
        </a>
        )}

        <div className="list-item-navMenu">
            <div className="divider"></div>
        </div> */}

                {isLogged && (
                    <a
                        style={{ textTransform: "none" }}
                        className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                        onClick={() =>
                            openSingleSubcategoryModal(
                                activePage,
                                "favorite_games",
                                "Favorite_games",
                            )
                        }
                    >
                        <img
                            src="/assets/img/icon-btn/favorite_games-icon.svg"
                            style={{ filter: "invert(0)" }}
                            alt="Opzione 1"
                        />
                        {t("Favorite_games")}
                    </a>
                )}

                {!casinoSections["casino"] && activePage === "casino" && (
                    <>
                        {/* <div className="list-item-navMenu">
                <div className="divider"></div>
            </div> */}

                        {isLogged && (
                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino",
                                        "recent_casino",
                                        "Last_played",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/recent_casino-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Last_played")}
                            </a>
                        )}

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "megaways_casino",
                                    "Megaways",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/megaways_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Megaways")}
                        </a>

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "fruit_casino",
                                    "Fruit",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/fruit_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Fruit")}
                        </a>

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "tablegame_casino",
                                    "Table_games",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/tablegame_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Table_games")}
                        </a>

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "multiline_casino",
                                    "Multiline",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/multiline_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Multiline")}
                        </a>

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "videopoker_casino",
                                    "Video_poker",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/videopoker_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Video_poker")}
                        </a>

                        <a
                            style={{ textTransform: "none" }}
                            className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                            onClick={() =>
                                openSingleSubcategoryModal(
                                    "casino",
                                    "other_casino",
                                    "Other_games",
                                )
                            }
                        >
                            <img
                                src="/assets/img/icon-btn/other_casino-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Other_games")}
                        </a>
                    </>
                )}

                {!casinoSections["casino_live"] &&
                    activePage === "casino-live" && (
                        <>
                            {/* <div className="list-item-navMenu">
                <div className="divider"></div>
            </div> */}

                            {isLogged && (
                                <a
                                    style={{ textTransform: "none" }}
                                    className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                    onClick={() =>
                                        openSingleSubcategoryModal(
                                            "casino-live",
                                            "recent_live",
                                            "Last_played",
                                        )
                                    }
                                >
                                    <img
                                        src="/assets/img/icon-btn/recent_live-icon.png"
                                        alt="Opzione 1"
                                        style={{ filter: "invert(1)" }}
                                    />
                                    {t("Last_played")}
                                </a>
                            )}

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "roulette_live",
                                        "Roulette",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/roulette_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Roulette")}
                            </a>

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "blackjack_live",
                                        "Blackjack",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/blackjack_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Blackjack")}
                            </a>

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "baccarat_live",
                                        "Baccarat",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/baccarat_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Baccarat")}
                            </a>

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "showgame_live",
                                        "Show_games",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/showgame_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Show_games")}
                            </a>

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "asiangame_live",
                                        "Asian_games",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/asiangame_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Asian_games")}
                            </a>

                            <a
                                style={{ textTransform: "none" }}
                                className={`list-item-navMenu ${activePage === "" ? "active" : ""}`}
                                onClick={() =>
                                    openSingleSubcategoryModal(
                                        "casino-live",
                                        "other_live",
                                        "Other_games",
                                    )
                                }
                            >
                                <img
                                    src="/assets/img/icon-btn/other_live-icon.png"
                                    alt="Opzione 1"
                                    style={{ filter: "invert(1)" }}
                                />
                                {t("Other_games")}
                            </a>
                        </>
                    )}

                <div className="list-item-navMenu">
                    <div className="divider"></div>
                </div>

                <h3 className="title-section-game">{t("Casino")}</h3>
                {!casinoSections["casino"] && (
                    <a
                        className={`list-item-navMenu ${activePage === "casino" ? "active" : ""}`}
                        onClick={() => handleButtonClick("casino")}
                    >
                        <img
                            src="/assets/img/icon-btn/slot-icon.png"
                            alt="Opzione 1"
                            style={{ filter: "invert(1)" }}
                        />
                        {t("Slot")}
                    </a>
                )}

                {!casinoSections["casino_live"] && (
                    <a
                        className={`list-item-navMenu ${activePage === "casino-live" ? "active" : ""}`}
                        onClick={() => handleButtonClick("casino-live")}
                    >
                        <img
                            src="/assets/img/icon-btn/live-game-icon.png"
                            alt="Opzione 1"
                            style={{ filter: "invert(1)" }}
                        />
                        {t("Casino")}
                    </a>
                )}

                {!casinoSections["crash_games"] && (
                    <a
                        className={`list-item-navMenu ${activePage === "crash-game" ? "active" : ""}`}
                        onClick={() => handleButtonClick("crash-game")}
                    >
                        <img
                            src="/assets/img/icon-btn/crash-game-icon.png"
                            alt="Opzione 1"
                            style={{ filter: "invert(1)" }}
                        />
                        {t("Crash_game")}
                    </a>
                )}

                {!casinoSections["bingo"] && (
                    <a
                        className={`list-item-navMenu ${activePage === "bingo" ? "active" : ""}`}
                        onClick={() => handleButtonClick("bingo")}
                    >
                        <img
                            src="/assets/img/icon-btn/bingo-icon.png"
                            alt=""
                            style={{ filter: "invert(1)" }}
                        />
                        {t("Bingo")}
                    </a>
                )}

                {!casinoSections["virtual"] && (
                    <>
                        <a
                            className={`list-item-navMenu ${activePage === "virtual" ? "active" : ""}`}
                            onClick={() => handleButtonClick("virtual")}
                        >
                            <img
                                src="/assets/img/icon-btn/virtual-icon.png"
                                alt="Opzione 1"
                                style={{ filter: "invert(1)" }}
                            />
                            {t("Virtual")}
                        </a>
                    </>
                )}

                <div className="list-item-navMenu">
                    <div className="divider"></div>
                </div>

                <h3 className="title-section-game">Provider</h3>
                {providers && providers.length > 0 ? (
                    providers.map((provider) => (
                        <a
                            key={provider.id}
                            className="list-item-navMenu"
                            onClick={() => openSingleProviderModal(provider)}
                        >
                            <img
                                src={getProviderIcon(provider.slug)}
                                alt={provider.name}
                            />{" "}
                            {provider.name}
                        </a>
                    ))
                ) : (
                    <p>Loading providers...</p>
                )}
            </div>

            {/* Використання Suspense для завантаження модального вікна */}
        </>
    );
};

export default MobileNavigation;
